import React, { useEffect, useRef } from "react";
import {
  defineBlock,
  smartProps,
  EditableImg,
  useEditor,
  useSmartProp,
  useInspectorControl,
} from "@smartfire/gutenberg-react";
import { PanelBody, PanelRow, TextControl } from "@wordpress/components";
import EditableText from "../shared/editable-text";
import style from "./block.module.scss";

function Inspector() {
  const [anchorName, setAnchorName] = useSmartProp("anchorName");
  return (
    <>
      <PanelBody title="Configuration ancre" initialOpen={true}>
        <PanelRow>
          <TextControl
            label={"Nom de l'ancre"}
            value={anchorName}
            onChange={(value) => setAnchorName(value)}
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ anchorName, image, title }) {
  const { isEditing } = useEditor();
  useInspectorControl(Inspector);

  const ref = useRef();

  useEffect(() => {
    const hash = window.location.hash.substr(1);
    if (hash) {
      if (ref) {
        let timer = setTimeout(
          () => window.scrollTo(0, ref.current.getBoundingClientRect().top),
          1000
        );
        return () => {
          clearTimeout(timer);
        };
      }
    }
  }, []);

  return (
    <div className={style.block} id={anchorName} ref={ref}>
      {(isEditing || (!isEditing && title.length > 0)) && (
        <>
          <div className={style.content}>
            <EditableText
              className={style.title}
              tagName="h2"
              smartProp="title"
              placeholder={"Entrez un titre"}
            />
            <div className={style.tiret} />
          </div>
        </>
      )}
      <div className={style.textImgRow}>
        {(isEditing || (!isEditing && image)) && (
          <EditableImg smartProp="image" className={style.image} />
        )}
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault(""),
    text: smartProps.string.withDefault(""),
    image: smartProps.any.withDefault(""),
    anchorName: smartProps.string.withDefault(""),
  },
  setup: {
    title: "Contenu + ancre",
  },
});
